export default __webpack_public_path__ + "stumbler-phone.33bf2854.png";